import { render, staticRenderFns } from "./b-flip-header.vue?vue&type=template&id=914fd500&scoped=true"
import script from "./b-flip-header.vue?vue&type=script&lang=js"
export * from "./b-flip-header.vue?vue&type=script&lang=js"
import style0 from "./b-flip-header.vue?vue&type=style&index=0&id=914fd500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914fd500",
  null
  
)

export default component.exports